import React, { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { initDwellTracking } from "@/lib/dwell";
import Preloader from "@/components/Preloader";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import MoltenHero from "@/components/MoltenHero";
import Offerings from "@/components/Offerings";
import Pricing from "@/components/Pricing";
import ProjectGallery from "@/components/ProjectGallery";
import VideoBand from "@/components/VideoBand";
import ServicesGrid from "@/components/ServicesGrid";
import Concierge from "@/components/Concierge";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    if (typeof window !== "undefined") window.__lenis = lenis;

    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  useEffect(() => {
    const stop = initDwellTracking();
    return stop;
  }, []);

  return (
    <div className="App grain">
      <Preloader />
      <CustomCursor />
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0d0d0d", border: "1px solid rgba(197,160,89,0.3)", color: "#fff" } }} />
      <Navbar />
      <MoltenHero />
      <Offerings />
      <Pricing />
      <ProjectGallery />
      <VideoBand />
      <ServicesGrid />
      <Concierge />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
